export var PublicDataScopes = {
    APP: 'APP',
    COMPONENT: 'COMPONENT',
};
//# sourceMappingURL=public-data-scopes.js.map